import React from 'react'
import {DialogManager} from '@modifi/plugin-dialogs'
import {CustomerDialogLayout, DefaultThemeProvider} from '@modifi/ui'

// @todo move
const Wrapped = props => (
  <DefaultThemeProvider>
    <CustomerDialogLayout {...props} />
  </DefaultThemeProvider>
)

DialogManager.setDefaultLayout(Wrapped)
